import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const tipoActivoImporterSelectors = importerSelectors(
  'tipoActivo.importer',
);

export default tipoActivoImporterSelectors;
